import { useState } from "react";
import { X, Plus } from "lucide-react";
import { cn } from "@/lib/utils";

export const ChipInput = ({ values = [], onChange, placeholder = "Add and press Enter", testId, tone = "brand" }) => {
  const [draft, setDraft] = useState("");
  const add = () => {
    const v = draft.trim();
    if (v && !values.some((x) => x.toLowerCase() === v.toLowerCase())) onChange([...values, v]);
    setDraft("");
  };
  const remove = (i) => onChange(values.filter((_, idx) => idx !== i));
  const toneCls = tone === "teal" ? "bg-teal-tint text-teal border-[#CBD8CF]" : "bg-brand-tint text-brand border-[#C9DACE]";

  return (
    <div data-testid={testId} className="flex flex-wrap items-center gap-2 rounded-lg border border-line bg-white p-2">
      {values.map((v, i) => (
        <span key={`${v}-${i}`} className={cn("inline-flex items-center gap-1 rounded-full border px-2.5 py-1 text-xs font-medium", toneCls)}>
          {v}
          <button
            type="button"
            aria-label={`Remove ${v}`}
            data-testid={`${testId}-remove-${i}`}
            onClick={() => remove(i)}
            className="rounded-full p-0.5 hover:bg-white/70 transition-colors duration-150"
          >
            <X size={12} />
          </button>
        </span>
      ))}
      <div className="flex flex-1 items-center gap-1 min-w-[140px]">
        <input
          data-testid={`${testId}-input`}
          value={draft}
          onChange={(e) => setDraft(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === ",") { e.preventDefault(); add(); }
            if (e.key === "Backspace" && !draft && values.length) remove(values.length - 1);
          }}
          onBlur={add}
          placeholder={placeholder}
          className="flex-1 bg-transparent px-1 py-1 text-sm outline-none placeholder:text-ink-muted"
        />
        {draft && (
          <button type="button" onMouseDown={(e) => e.preventDefault()} onClick={add} className="text-brand" aria-label="Add">
            <Plus size={16} />
          </button>
        )}
      </div>
    </div>
  );
};

export const Chips = ({ values = [], tone = "brand", empty = "None specified" }) => {
  if (!values.length) return <p className="text-sm text-ink-muted">{empty}</p>;
  const toneCls = tone === "teal" ? "bg-teal-tint text-teal border-[#CBD8CF]" : tone === "neutral"
    ? "bg-subtle text-ink-secondary border-line" : "bg-brand-tint text-brand border-[#C9DACE]";
  return (
    <div className="flex flex-wrap gap-2">
      {values.map((v, i) => (
        <span key={`${v}-${i}`} className={cn("rounded-full border px-2.5 py-1 text-xs font-medium", toneCls)}>{v}</span>
      ))}
    </div>
  );
};
